import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { renderDatePicker } from '../../Utils/renderField/renderField';

const LoadDatesForm = (props) => {
  const { handleSubmit } = props;

  return (
     <form onSubmit={handleSubmit}>
        <div className="expense-tickets__filter-row">
           <div className="expense-tickets__date-inputs">
              <div className="expense-tickets__date-input-wrapper">
                 <label>Start Date</label>
                 <Field
                    name="startDate"
                    component={renderDatePicker}
                    type="date"
                    defaultValue="2027-12-01"
                    className="p-1"
                    numberOfMonths={1}
                    isOutsideRange={false}
                 />
              </div>

              <div className="expense-tickets__date-input-wrapper">
                 <label>End Date</label>
                 <Field
                    name="endDate"
                    component={renderDatePicker}
                    type="date"
                    className="p-1"
                    defaultValue="2027-12-31"
                    numberOfMonths={1}
                    isOutsideRange={false}
                 />
              </div>
           </div>

           <div className="expense-tickets__radio-filters">
              <div className="d-flex align-items-center">
                 <Field id="all" component={'input'} type="radio" name="expense_filter" value="all" />
                 <label className="mb-0 ml-1">All</label>
              </div>
              <div className="d-flex align-items-center">
                 <Field id="toll_only" component={'input'} type="radio" name="expense_filter" value="toll-only" />
                 <label className="mb-0 ml-1">Toll Only</label>
              </div>

              <div className="d-flex align-items-center">
                 <Field id="expense_only" component={'input'} type="radio" name="expense_filter" value="expense_only" />
                 <label className="mb-0 ml-1">Driver Expense Only</label>
              </div>
           </div>

           <button type="submit" className="expense-tickets__load-btn">
              LOAD
           </button>
        </div>
     </form>
  );
};

export default reduxForm({
  form: 'loadDatesForm',
   initialValues: {
    expense_filter: 'all' // ← Esta es la opción que quedará marcada al cargar
  }
})(LoadDatesForm);
